"use client"
import {
  Menu
} from "./chunk-ULYETFJE.mjs";

// src/components/context-menu.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var ContextMenu = mergeMultiStyle(
  Menu,
  {
    baseStyle: {
      trigger: {}
    }
  }
)();

export {
  ContextMenu
};
//# sourceMappingURL=chunk-57JH7ZHH.mjs.map